import { getCurrentInstance } from 'vue';
/**
 * @deprecated use vuex useStore instead, this composable will be removed soon
 */
export function useStore() {
  const currentInstance = getCurrentInstance();

  return currentInstance.proxy.$store;
}
